import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import ScheduleGradeAircraftLineChanged from './Elements/ScheduleGradeAircraftLineChanged';
import ScheduleGradeObservationModal from '../ScheduleGrades/Elements/ScheduleGradeObservationModal';
import ScheduleGradeAircraftLineChangedOriginalView from './Elements/ScheduleGradeAircraftLineChangedOriginalView';
import ScheduleGradeAircraftLine from './Elements/ScheduleGradeAircraftLine';
import ScheduleGradeAircraftLineAlternate from './Elements/ScheduleGradeAircraftLineAlternate';
import ScheduleGradeAircraftLineAlternateExtra from './Elements/ScheduleGradeAircraftLineAlternateExtra';
import ScheduleUsedRegimeEdit from './Elements/ScheduleUsedRegimeEdit';
import getLocale from '../../i18n/getLocale';


class SchedulesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      blocked_approval: 0,
      name: '',
      aircraft_model: '',
      date_start: '',
      date_finish: '',
      fortnight_1_date_start: '',
      fortnight_1_date_finish: '',
      fortnight_2_date_start: '',
      fortnight_2_date_finish: '',
      schedule_grades: [],
      schedule_used_regimes: [],
      schedule_grade: {},
      grade: {},
      schedule_changes: 0,
      change_days: null,
      change_days_without_aircraft: null,
      line_staffs_changed: {},
      removed_aircrafts: {},
      removed_bases: {},
      removed_staffs: {},
      new_aircrafts: {},
      new_bases: {},
      new_staffs: {},
      grade_alternate: {},
      initials_colors: {},
      schedule_days: {},
      modal: false,
      modal_alert: false,
      modal_alert_reserve: false,
      alerts: {},
      alerts_reserve: {},
      verification: 0,
      signing: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalAlert = this.closeModalAlert.bind(this);
    this.closeModalAlertReserve = this.closeModalAlertReserve.bind(this);
    this.closeModalAlertOfficialize = this.closeModalAlertOfficialize.bind(this);
    this.getInfoEscala = this.getInfoEscala.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
    this.viewAlerts = this.viewAlerts.bind(this);
    this.viewAlertsReserve = this.viewAlertsReserve.bind(this);
    this.openObservationsInput = this.openObservationsInput.bind(this);
    this.officialize = this.officialize.bind(this);
    this.verify = this.verify.bind(this);
    this.approve = this.approve.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.deleteGrade = this.deleteGrade.bind(this);
    this.exportPdfGrade = this.exportPdfGrade.bind(this);
    this.exportPdfRevisionGrade = this.exportPdfRevisionGrade.bind(this);
    this.viewAlertsPdf = this.viewAlertsPdf.bind(this);
    this.export = this.export.bind(this);
    this.refreshGrades = this.refreshGrades.bind(this);
    this.blockApproval = this.blockApproval.bind(this);
    this.unblockApproval = this.unblockApproval.bind(this);
    this.addScheduleUsedRegime = this.addScheduleUsedRegime.bind(this);
    this.refreshScheduleRegimes = this.refreshScheduleRegimes.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  loadData (first_load) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            blocked_approval: responseJson.data.main.blocked_approval,
            aircraft_model: responseJson.data.main.aircraft_model.model,
            date_start: responseJson.data.main.date_start_str,
            date_finish: responseJson.data.main.date_finish_str,
            fortnight_1_date_start: responseJson.data.main.fortnight_1_date_start_str,
            fortnight_1_date_finish: responseJson.data.main.fortnight_1_date_finish_str,
            fortnight_2_date_start: responseJson.data.main.fortnight_2_date_start_str,
            fortnight_2_date_finish: responseJson.data.main.fortnight_2_date_finish_str,
            schedule_used_regimes: responseJson.data.schedule_used_regimes,
            next_schedule_id: responseJson.data.next_schedule_id,
            previous_schedule_id: responseJson.data.previous_schedule_id,
            schedule_regimes_escala: responseJson.data.schedule_regimes_escala,
            schedule_regimes_mestre: responseJson.data.schedule_regimes_mestre,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grades/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data});
        }
      }).then(() => {
        if(first_load === 1) {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }
      }); /* Overlay */ }); /* ScheduleGrades */
    });
  }

  refreshGrades (event) {
    var self = this;
    var header = self.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grades/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data});
        }
      }).then(() => {
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }

  refreshScheduleRegimes (event) {
    this.setState({schedule_used_regimes: event.data});
  }
  
  //Envia email com somatório de diárias de cada tripulante
  exportCsv(event) {
    var url = "/escala/grade/exportar/diarias/" + event;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }
  
  // Tento oficializar a escala
  officialize (schedule_grade_id) {
    var self = this;
    if (window.confirm(this.locale.Escalas.EditarEscala.efetivarGrade)) {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/efetivar/escala/' + self.props.match.params.id + '/' + schedule_grade_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(0);
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);
          } else {
            self.setState({alerts: responseJson.data});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            self.setState({modal_alert_officialize: true});
          }
        });
      });
    }
  }
  
  // abrimos input de observações
  openObservationsInput(schedule_grade_id) {
    var data = this.state.schedule_grades;
    data.map(function(dado, index){
      if (dado.id == schedule_grade_id) {
        dado.modal = true;
      }
    });
    this.setState({schedule_grades: data});
  }
  // gero os dados do modal de alertas da grade
  viewAlerts (schedule_grade_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/' + self.props.match.params.id + '/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }
  
  // gero os dados do modal de alertas da grade para reserva
  viewAlertsReserve (schedule_grade_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/reserva/' + self.props.match.params.id + '/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts_reserve: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert_reserve: true});
      })
    });
  }
  
  // gero os dados do modal de visualização da escala
  getInfoEscala (schedule_grade_id) {
    var self = this;
    self.setState({schedule_changes: 0});          
    self.setState({change_days: null});          
    self.setState({line_staffs_changed: null});
    self.setState({removed_aircrafts: null});
    self.setState({removed_bases: null});
    self.setState({removed_staffs: null});
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/aeronaves/escaladas/' + schedule_grade_id + '/1';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          if (responseJson.data.schedule_changes) {
            self.setState({schedule_changes: 1});          
            self.setState({change_days_without_aircraft: responseJson.data.schedule_changes.change_days_without_aircraft});          
            self.setState({change_days: responseJson.data.schedule_changes.change_days});          
            self.setState({line_staffs_changed: responseJson.data.schedule_changes.line_staffs_changed});
            self.setState({removed_aircrafts: responseJson.data.schedule_changes.removed_aircrafts});
            self.setState({removed_bases: responseJson.data.schedule_changes.removed_bases});
            self.setState({removed_staffs: responseJson.data.schedule_changes.removed_staffs});
            self.setState({new_aircrafts: responseJson.data.schedule_changes.new_aircrafts});
            self.setState({new_bases: responseJson.data.schedule_changes.new_bases});
            self.setState({new_staffs: responseJson.data.schedule_changes.new_staffs});
          }
          self.setState({grade: responseJson.data.main});
          self.setState({grade_extra_main: responseJson.data.extra_main});
          self.setState({grade_alternate: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grade/info/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          if(responseJson.data.warning === 1) {
            self.setState({error_schedule_pendencies_ids: responseJson.data.error_schedule_pendencies_ids});
            self.setState({errors_listing: true});
          }
          self.setState({schedule_grade: responseJson.data.schedule_grade});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/dias/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_days: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/siglas/cores';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({initials_colors: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal: true});
      }); /* Overlay */ }); /* info grade */ }); /* dias grade */ }); /* dias grade */ 
    });
  }

  // Modal para marcar como verificada
  verify(schedule_grade_id){
    this.setState({verification: 1});
    this.getInfoEscala(schedule_grade_id);
  }

  // Modal para marcar como verificada
  confirmVerify(schedule_grade_id){
    if (this.state.errors_listing === true) {
      var confirm = window.confirm(this.locale.Escalas.EditarEscala.trocarStatusDessaGradeParaVerificadaMesmoHavendoPendencias);
    } else {
      var confirm = window.confirm(this.locale.Escalas.EditarEscala.trocarStatusDessaGradeParaVerificada);
    }
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/verificar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  confirmSign(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscala.trocarStatusDessaGradeParaAprovada);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if(responseJson.status === 'success') {
            // window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  // Modal para marcar como verificada
  repproveGrade(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscala.trocarStatusDessaGradeParaRascunho);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/reprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  duplicate(schedule_grade_id){
    var confirm = window.confirm(this.locale.Escalas.EditarEscala.criarRevisaoDestaGrade);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/duplicar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  //Gerar pdf
  exportPdfRevisionGrade(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/revisao/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.refreshGrades(responseJson);
        window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);       
      })
    });
  }
  
  exportPdfGrade(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get('cdn') + '/schedule_grades/main/' + responseJson.data);       
      })
    });
  }
  
  viewAlertsPdf(schedule_grade_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/alertas/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.refreshGrades(responseJson);
        window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
      })
    });
  }
  
  // Modal para marcar como verificada
  approve(schedule_grade_id){
    this.setState({signing: 1});
    this.getInfoEscala(schedule_grade_id);
  }

  // Fecha modal
  closeModal(event){
    this.setState({modal: false, grade: [], grade_alternate: [], schedule_grade: {}, verification: 0, signing: 0});
  }
  // Fecha modal
  closeModalAlert(event){
    this.setState({modal_alert: false, alerts: {}});
  }

  // Fecha modal
  closeModalAlertReserve(event){
    this.setState({modal_alert_reserve: false, alerts_reserve: {}});
  }

  // Fecha modal
  closeModalAlertOfficialize(event){
    this.setState({modal_alert_officialize: false, alerts: {}});
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      fortnight_1_date_start: this.state.fortnight_1_date_start,
      fortnight_1_date_finish: this.state.fortnight_1_date_finish,
      fortnight_2_date_start: this.state.fortnight_2_date_start,
      fortnight_2_date_finish: this.state.fortnight_2_date_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  deleteGrade (event) {
    var schedule_grade_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Escalas.EditarEscala.deletarGrade);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/' + schedule_grade_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshGrades(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  export(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportacao/escala/viagem/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get('cdn') + '/tmp/' + responseJson.data);
      })
    });
  }

  blockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/bloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({blocked_approval: responseJson.data.blocked_approval});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }

  unblockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/desbloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({blocked_approval: responseJson.data.blocked_approval});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }

  addScheduleUsedRegime (event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.state.id,
      schedule_regime_id: this.state.schedule_regime_id,
      start_day: this.state.start_day,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/uso/regime', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({schedule_used_regimes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          {this.state.previous_schedule_id ? 
            <a href={'/escala/editar/' + this.state.previous_schedule_id} className={'btn btn-primary'}>
              <i className="fa fa-fw fa-chevron-left"></i>
            </a>
            : 
            ""
          }
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.aircraft_model} - {this.state.name}</h3>
        </div>
        <div className="col-md-4 text-right">
          {this.state.next_schedule_id ? 
            <a href={'/escala/editar/' + this.state.next_schedule_id} className={'btn btn-primary'}>
              <i className="fa fa-fw fa-chevron-right"></i>
            </a>
            : 
            ""
          }
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.Escalas.EditarEscala.titulo} - {this.state.aircraft_model} - {this.state.name}</h3>
      <Link to="/escalas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      {this.state.blocked_approval === 0 ? 
        <button onClick={self.blockApproval} className="pull-right btn btn-danger button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> {this.locale.Escalas.EditarEscala.botaoBloquearEscala}</button>
        : 
        <button onClick={self.unblockApproval} className="pull-right btn btn-success button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> {this.locale.Escalas.EditarEscala.botaoDesbloquearEscala}</button>
      }
      <div className="clearfix"></div>
      <hr/>
      <div className="row">
        <div className="col-md-1 pull-left">
          <div className="form-group">
            <label>{this.locale.Escalas.EditarEscala.formulario.DataInicial}</label>
            <p>{this.state.date_start}</p>
          </div>
        </div>
        <div className="col-md-1 pull-right">
          <div className="form-group">
            <label>{this.locale.Escalas.EditarEscala.formulario.DataFinal}</label>
            <p>{this.state.date_finish}</p>
          </div>
        </div>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloGrades}</h3>
      <hr/>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-1 text-center">{this.locale.Escalas.EditarEscala.tabelaGrades.Revisao}</th>
            <th className="col-md-2 text-center">{this.locale.Escalas.EditarEscala.tabelaGrades.Status}</th>
            <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaGrades.Efetivacao}</th>
            <th className="col-md-8 text-center">{this.locale.Escalas.EditarEscala.tabelaGrades.Acoes}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.schedule_grades).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.schedule_grades[k].revision}</td>
                <td className="text-center">{self.state.schedule_grades[k].status_str}</td>
                <td>{self.state.schedule_grades[k].partial === 1 ? 'Efetivação Parcial' : self.state.schedule_grades[k].official === 1 ? "Efetivada" : ""}</td>
                <td className="text-center">
                  {(self.state.schedule_grades[k].status === 'draft') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button onClick={self.exportPdfRevisionGrade} className="btn btn-warning button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-file-pdf-o"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoGerarPDF}</button>
                      <Link to={"/escala/grade/" + self.state.schedule_grades[k].id} className="btn btn-success button-inline" ><i className="fa fa-fw fa-pencil"></i> {self.locale.general.editar}</Link>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.verify(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoMarcarComoVerificada}</button>
                      <button className="btn btn-warning" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoAlertas}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlertsPdf(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                      <button className="btn btn-danger button-inline" value={self.state.schedule_grades[k].id} onClick={self.deleteGrade}><i className="fa fa-fw fa-trash"></i></button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'verified') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.approve(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoMarcarComoAprovada}</button>
                      <button className="btn btn-warning" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoAlertas}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlertsPdf(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'approved') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.duplicate(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-refresh"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoCriarRevisao}</button>
                      <button onClick={self.export} className="btn btn-success button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-plane"></i></button>
                      <button onClick={self.exportPdfGrade} className="btn btn-warning button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-file-pdf-o"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoGerarPDF}</button>
                      <button className="btn btn-info button-inline" onClick={() => self.openObservationsInput(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-align-left"></i></button>
                      <button className="btn btn-warning" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoAlertas}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlertsPdf(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                      {(self.state.schedule_grades[k].official === 1 && self.state.schedule_grades[k].partial === 1) ? 
                        <button className="btn btn-primary button-inline" onClick={() => { self.officialize(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoEfetivar}</button>
                        : (self.state.schedule_grades[k].official === 1) ?
                        <button className="btn btn-primary button-inline" disabled><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoEscalaEfetivada}</button>
                        :
                        <button className="btn btn-primary button-inline" onClick={() => { self.officialize(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-check"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoEfetivar}</button>
                      }
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'deprecated') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={() => self.getInfoEscala(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-eye"></i></button>
                      <button onClick={self.exportPdfGrade} className="btn btn-warning button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-file-pdf-o"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoGerarPDF}</button>
                      <button className="btn btn-warning" onClick={() => { self.viewAlerts(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-warning"></i> {self.locale.Escalas.EditarEscala.tabelaGrades.botaoAlertas}</button>
                      <button className="btn btn-warning button-inline" onClick={() => { self.viewAlertsPdf(self.state.schedule_grades[k].id) }}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'approving') ?  
                    <div>
                      <span className="label label-danger">{self.locale.Escalas.EditarEscala.tabelaGrades.EstamosProcessandoAAprovacao}</span>
                    </div>
                    : ''
                  }
                  <ScheduleGradeObservationModal handleAlert={self.props.handleAlert} modalPropsOff={self.openObservationsInput} updateData={self.refreshGrades} modal_props={self.state.schedule_grades[k].modal} schedule_grade_id={self.state.schedule_grades[k].id} observations={self.state.schedule_grades[k].observations}/>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <hr/>
      <h4>{this.locale.Escalas.EditarEscala.tituloRegimesDeTrabalho}</h4>
      <hr/>
      <form onSubmit={this.addScheduleUsedRegime}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscala.formularioRegimesDeTrabalho.Regime}:</label>
              <Select
                className="form-field-name"
                name="schedule_regime_id"
                value={this.state.schedule_regime_id}
                searchable={true}
                placeholder={this.locale.Escalas.EditarEscala.formularioRegimesDeTrabalho.placeholder.SelecioneORegime}
                onChange={this.handleSelectChange.bind(this, 'schedule_regime_id')}
                options={this.state.schedule_regimes_escala}
              />    
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Escalas.EditarEscala.formularioRegimesDeTrabalho.DataDeInicio}:</label>
              <InputMask value={this.state.start_day}  maskChar={null} name="start_day" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start_day')} placeholder="" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Escalas.EditarEscala.tituloRegimesEmUso}</h4>
      <hr/>
      {(this.state.schedule_used_regimes === null || typeof this.state.schedule_used_regimes === 'undefined') ?  '' 
      : 
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.Escalas.EditarEscala.tabelaRegimesEmUso.ID}
              </th>
              <th>
                {this.locale.Escalas.EditarEscala.tabelaRegimesEmUso.Regime}
              </th>
              <th>
                {this.locale.Escalas.EditarEscala.tabelaRegimesEmUso.DataDeInicio}
              </th>
              <th>{this.locale.Escalas.EditarEscala.tabelaRegimesEmUso.Acoes}</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(self.state.schedule_used_regimes).map(function(k) {
              return (
                <ScheduleUsedRegimeEdit
                  id={self.state.schedule_used_regimes[k].id}
                  schedule_regime={self.state.schedule_used_regimes[k].schedule_regime.name}
                  start_day={self.state.schedule_used_regimes[k].start_day_str}
                  handleAlert={self.handleAlert}
                  refreshScheduleRegimes={self.refreshScheduleRegimes}
                />
              );
            })}
          </tbody>
        </table>
      }
    </div>
  </div>
  <Modal show={this.state.modal_alert_officialize} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscala.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.aircraft_model} - {this.state.name} - <strong>{this.locale.Escalas.EditarEscala.tituloAlertasImpeditivos}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlertOfficialize}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger' && (alert.official === 1 || alert.exception === 1)) {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
      <table className="table table-bordered">
        <thead>
          <tr>
          <th className="col-md-1 text-center">{this.locale.Escalas.EditarEscala.tabelaAlertas.Matricula}</th>
            <th className="col-md-2 text-center">{this.locale.Escalas.EditarEscala.tabelaAlertas.Nome}</th>
            <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaAlertas.Setor}</th>
            <th className="col-md-8 text-center">{this.locale.Escalas.EditarEscala.tabelaAlertas.Alerta}</th>
          </tr>
        </thead>
        {Object.keys(self.state.alerts.personal_alerts).map(function(index_alert) {
          var alerts = self.state.alerts.personal_alerts[index_alert];
          var staff_data = index_alert.split('*');
          return(
            <tbody id="suppliers-certifications">
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger' && (alert.official === 1 || alert.exception === 1)) {
                  return(
                    <tr>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{staff_data[1]}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{staff_data[0]}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}></td>
                      <td className={"text-center box-alert box-alert-" + alert.color}><div dangerouslySetInnerHTML={{__html: alert.message}}></div></td>
                    </tr>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
            </tbody>
          );
        })}
        </table>
        </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlertOfficialize}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscala.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.aircraft_model} - {this.state.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-1 text-center">{this.locale.Escalas.EditarEscala.tabelaAlertasCompacta.NomeMatricula}</th>
            <th className="col-md-8 text-center">{this.locale.Escalas.EditarEscala.tabelaAlertasCompacta.Alerta}</th>
          </tr>
        </thead>
        {Object.keys(self.state.alerts.personal_alerts).map(function(index_alert) {
          var alerts = self.state.alerts.personal_alerts[index_alert];
          var staff_data = index_alert.split('*');
          return(
            <tbody id="suppliers-certifications">
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger') {
                  return(
                    <tr>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{staff_data[0]}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}><div dangerouslySetInnerHTML={{__html: alert.message}}></div></td>
                    </tr>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
            </tbody>
          );
        })}
        </table>
        </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_alert_reserve} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscala.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.aircraft_model} - {this.state.name} - ALERTAS DE TRIPULAÇÃO DE RESERVA</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlertReserve}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {Object.keys(self.state.alerts_reserve).map(function(k) {
        var alert_info = self.state.alerts_reserve[k];
        var alerts = alert_info.alerts;
        return(
          <div>
            <h4><strong>{alert_info.title}</strong></h4>
            {Object.keys(alerts).map(function(k) {
              var alert = alerts[k];
              return(
                <div className={"box-alert box-alert-" + alert.color}>
                    <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                </div>
              );
            })}
            <hr/>
          </div>
        );
      })}

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModalAlertReserve}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Escalas.EditarEscala.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.aircraft_model} - {this.state.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, error_schedule_pendencies_ids: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Escalas.EditarEscala.existemAsSeguintesPendencias}:</strong>
          {Object.keys(self.state.error_schedule_pendencies_ids).map(function(k) {
            var id = self.state.error_schedule_pendencies_ids[k];
            return (
              <p>ID - {id}</p>
            );  
          })}
        </div>
      }
    </Modal.Header>
    <Modal.Body>
      {(self.state.verification === 1) ?  
        <div>
          <button className="btn btn-primary btn-block btn-lg" onClick={() => self.confirmVerify(self.state.schedule_grade.id)}><i className="fa fa-fw fa-check"></i> {this.locale.Escalas.EditarEscala.botaoConfirmarMudancaDeStatusParaVerificada}</button>
          <hr/>
        </div> 
      : ""
      }
      {(self.state.signing === 1) ?  
        <div>
          <button className="btn btn-warning btn-block btn-lg" onClick={() => self.repproveGrade(self.state.schedule_grade.id)}><i className="fa fa-fw fa-left"></i> {this.locale.Escalas.EditarEscala.botaoVoltarParaRascunho}</button>
          <button className="btn btn-primary btn-block btn-lg" onClick={() => self.confirmSign(self.state.schedule_grade.id)}><i className="fa fa-fw fa-check"></i> {this.locale.Escalas.EditarEscala.botaoAprovarEscala}</button>
          <hr/>
        </div> 
      : ""
      }
      {(this.state.grade === null || typeof this.state.grade === 'undefined') ?  <div><small><em>{this.locale.Escalas.EditarEscala.nenhumaAeronaveEscalada}</em></small><hr/></div> 
      : 
      <div className="table-schedule-container">
        {(self.state.schedule_grade.status === "approved") ? <div><button className="btn btn-sm btn-success" disabled={'disabled'}> {this.locale.Escalas.EditarEscala.botaoAprovado} - {(self.state.schedule_grade.user) ? self.state.schedule_grade.user.name : ""}</button><hr/></div> : ""}
        
        <table className="table table-schedule table-bordered">
          <thead>
            <tr>
              <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaVisualizarEscala.Base}</th>
              <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaVisualizarEscala.Aeronave}</th>
              <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaVisualizarEscala.Grupo}</th>
              <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaVisualizarEscala.Nome}</th>
              <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaVisualizarEscala.Matricula}</th>
              <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaVisualizarEscala.Designacao}</th>
              {Object.keys(self.state.schedule_days).map(function(k) {
                var day = self.state.schedule_days[k];
                return(
                  <th>{day.weekday}</th>
                );
              })}
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              {Object.keys(self.state.schedule_days).map(function(k) {
                var day = self.state.schedule_days[k];
                return(
                  <th>{day.day_simple}</th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.grade).map(function(k) {
              var sgas = self.state.grade[k];
              return(
                <ScheduleGradeAircraftLine schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
              );
            })}
          </tbody>
        </table>
        <hr/>
      </div>
      }
      {(this.state.grade_extra_main === null || typeof this.state.grade_extra_main === 'undefined') ?  '' 
      : 
        <div>
          {(this.state.grade_extra_main !== null && typeof this.state.grade_extra_main !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloTripulacaoExtra}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaTripulacaoExtra.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaTripulacaoExtra.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaTripulacaoExtra.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_extra_main).map(function(k) {
                    var sgas = self.state.grade_extra_main[k];
                    return(
                      <ScheduleGradeAircraftLineAlternateExtra schedule_id={self.state.schedule_id}sgas={sgas} schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} />
                    );
                  })}
                </tbody>
              </table>
            </div>
          : ''
          }      
        </div>
      }
      {(this.state.grade_alternate === null || typeof this.state.grade_alternate === 'undefined') ?  '' 
      : 
        <div>
          {(this.state.grade_alternate.INS !== null && typeof this.state.grade_alternate.INS !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloInstrucao}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaInstrucao.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaInstrucao.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaInstrucao.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.INS).map(function(k) {
                    var sgas = self.state.grade_alternate.INS[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.EQUIP !== null && typeof this.state.grade_alternate.EQUIP !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloChefeDeEquipamento}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaChefeDeEquipamento.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaChefeDeEquipamento.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaChefeDeEquipamento.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.EQUIP).map(function(k) {
                    var sgas = self.state.grade_alternate.EQUIP[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.MEDICA !== null && typeof this.state.grade_alternate.MEDICA !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloDispensaMedica}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaDispensaMedica.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaDispensaMedica.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaDispensaMedica.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.MEDICA).map(function(k) {
                    var sgas = self.state.grade_alternate.MEDICA[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.MANUT !== null && typeof this.state.grade_alternate.MANUT !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloManutencao}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaManutencao.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaManutencao.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaManutencao.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.MANUT).map(function(k) {
                    var sgas = self.state.grade_alternate.MANUT[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.FERIAS !== null && typeof this.state.grade_alternate.FERIAS !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloFerias}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaFerias.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaFerias.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaFerias.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.FERIAS).map(function(k) {
                    var sgas = self.state.grade_alternate.FERIAS[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.FORA !== null && typeof this.state.grade_alternate.FORA !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloForaDeEscala}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaForaDeEscala.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaForaDeEscala.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaForaDeEscala.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.FORA).map(function(k) {
                    var sgas = self.state.grade_alternate.FORA[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          {(this.state.grade_alternate.EXTRA !== null && typeof this.state.grade_alternate.EXTRA !== 'undefined') ?  
            <div className="table-schedule-container-simple">
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloTripulacaoExtra}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaTripulacaoExtra.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaTripulacaoExtra.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaTripulacaoExtra.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.grade_alternate.EXTRA).map(function(k) {
                    var sgas = self.state.grade_alternate.EXTRA[k];
                    return(
                      <ScheduleGradeAircraftLineAlternate schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          : ''
          }
          
        </div>
      }
      {(self.state.schedule_changes === 1) ?
        <div>
          <hr/>
          <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloAlteracoesNaEscala}</h3>
          {(self.state.removed_bases === null || typeof self.state.removed_bases === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.removed_bases).map(function(k) {
                var rb = self.state.removed_bases[k];
                return(
                  <p>{rb}</p>
                );
              })}
            </div>
          }
          {(self.state.new_bases === null || typeof self.state.new_bases === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.new_bases).map(function(k) {
                var nb = self.state.new_bases[k];
                return(
                  <p>{nb}</p>
                );
              })}
            </div>
          }
          {(self.state.removed_aircrafts === null || typeof self.state.removed_aircrafts === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.removed_aircrafts).map(function(k) {
                var ra = self.state.removed_aircrafts[k];
                return(
                  <p>{ra}</p>
                );
              })}
            </div>
          }
          {(self.state.new_aircrafts === null || typeof self.state.new_aircrafts === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.new_aircrafts).map(function(k) {
                var na = self.state.new_aircrafts[k];
                return(
                  <p>{na}</p>
                );
              })}
            </div>
          }
          {(self.state.removed_staffs === null || typeof self.state.removed_staffs === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.removed_staffs).map(function(k) {
                var rs = self.state.removed_staffs[k];
                return(
                  <p>{rs}</p>
                );
              })}
            </div>
          }
          {(self.state.new_staffs === null || typeof self.state.new_staffs === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.new_staffs).map(function(k) {
                var ns = self.state.new_staffs[k];
                return(
                  <p>{ns}</p>
                );
              })}
            </div>
          }
          {(self.state.line_staffs_changed === null || typeof self.state.line_staffs_changed === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.line_staffs_changed).map(function(k) {
                var lsc = self.state.line_staffs_changed[k];
                return(
                  <p>{lsc}</p>
                );
              })}
            </div>
          }
          
          {(self.state.change_days_without_aircraft === null || typeof self.state.change_days_without_aircraft === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.change_days_without_aircraft).map(function(k) {
                var sgas = self.state.change_days_without_aircraft[k];
                return(
                  <p>{sgas.days_changed_message}</p>
                );
              })}
            </div>
          }
          {(self.state.change_days_without_aircraft === null || typeof self.state.change_days_without_aircraft === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloRevisaoAtual}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days_without_aircraft).map(function(k) {
                    var sgas = self.state.change_days_without_aircraft[k];
                    return(
                      <ScheduleGradeAircraftLineChanged schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
          {(self.state.change_days_without_aircraft === null || typeof self.state.change_days_without_aircraft === 'undefined') ?  <div><hr/><small><em>Nenhuma alteração nas subescalas de tripulantes.</em></small></div> 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloRevisaoAnterior}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days_without_aircraft).map(function(k) {
                    var sgas = self.state.change_days_without_aircraft[k];
                    return(
                      <ScheduleGradeAircraftLineChangedOriginalView schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
          
          {(self.state.change_days === null || typeof self.state.change_days === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              {Object.keys(self.state.change_days).map(function(k) {
                var sgas = self.state.change_days[k];
                return(
                  <p>{sgas.days_changed_message}</p>
                );
              })}
            </div>
          }
          {(self.state.change_days === null || typeof self.state.change_days === 'undefined') ?  '' 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloRevisaoAtual}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAtual.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days).map(function(k) {
                    var sgas = self.state.change_days[k];
                    return(
                      <ScheduleGradeAircraftLineChanged schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
          {(self.state.change_days === null || typeof self.state.change_days === 'undefined') ?  <div><hr/><small><em>Nenhuma alteração na escala principal de tripulantes.</em></small></div> 
          : 
            <div className="table-schedule-container">     
              <hr/>
              <h3 className="page-title">{this.locale.Escalas.EditarEscala.tituloRevisaoAnterior}</h3>
              <hr/>
              <table className="table table-schedule table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Base}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Aeronave}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Grupo}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Nome}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Matricula}</th>
                    <th className="text-center">{this.locale.Escalas.EditarEscala.tabelaRevisaoAnterior.Designacao}</th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.weekday}</th>
                      );
                    })}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    {Object.keys(self.state.schedule_days).map(function(k) {
                      var day = self.state.schedule_days[k];
                      return(
                        <th>{day.day_simple}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.change_days).map(function(k) {
                    var sgas = self.state.change_days[k];
                    return(
                      <ScheduleGradeAircraftLineChangedOriginalView schedule_days={self.state.schedule_days} initials_colors={self.state.initials_colors} sgas={sgas} />
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
          }
        </div>
        : ''
      }


    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default SchedulesEdit;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesEdit.js